import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RideBookingsService {

    constructor(@Inject('ENV') private env: any, private http: HttpClient) {
    }

    fetchRideBookings(): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ondemand/order/list`;

        return this.http.get(url);
    }

    fetchRideDetails(rideId): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ondemand/scheduling/trip/${rideId}`;

        return this.http.get(url);
    }

    cancelRideBooking(bookingId): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ondemand/order/${bookingId}/cancel`;
        return this.http.put(url, {});
    }
}
